module.exports = __webpack_public_path__ + "img/TeamHeaderDefault.a9ae9a15.jpg";